/* ==========================================================================
   Metcos Conversion Suite
   Live viewers  ·  Units sold  ·  Frequently bought together  ·  Purchase popup

   Design notes
   - One file, no dependencies, no network calls on load. Everything the
     widgets need is baked into the page by Liquid at render time.
   - Counters are seeded from the product id, so a given product shows the
     same believable band to everyone and does not reset to a wild number
     on refresh.
   - Every timer stops when the tab is hidden, so nothing burns battery in
     a background tab.
   ========================================================================== */

(function () {
  'use strict';

  // ------------------------------------------------------------------
  // Config
  // ------------------------------------------------------------------

  var CONFIG = {};
  try {
    var configEl = document.getElementById('MdjConfig');
    if (configEl) CONFIG = JSON.parse(configEl.textContent) || {};
  } catch (e) {
    CONFIG = {};
  }

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ------------------------------------------------------------------
  // Seeded pseudo-random helpers
  //
  // Math.random() would give every visitor a different number and a fresh
  // one on every refresh, which is exactly what makes these widgets look
  // fake. Seeding from the product id keeps a product's numbers coherent.
  // ------------------------------------------------------------------

  function hashString(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function mulberry32(seed) {
    return function () {
      seed |= 0;
      seed = (seed + 0x6d2b79f5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function seededInt(seedStr, min, max) {
    var rnd = mulberry32(hashString(String(seedStr)));
    rnd();
    return Math.floor(rnd() * (max - min + 1)) + min;
  }

  function randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  // ------------------------------------------------------------------
  // Visibility-aware interval
  //
  // Wraps setInterval so the callback is suspended while the tab is in the
  // background and resumes cleanly when the shopper comes back.
  // ------------------------------------------------------------------

  function LiveInterval(fn, ms) {
    this.fn = fn;
    this.ms = ms;
    this.id = null;
    this.stopped = false;
    var self = this;

    this.start = function () {
      if (self.stopped || self.id !== null) return;
      self.id = setInterval(self.fn, self.ms);
    };

    this.pause = function () {
      if (self.id !== null) {
        clearInterval(self.id);
        self.id = null;
      }
    };

    this.stop = function () {
      self.stopped = true;
      self.pause();
    };

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.pause();
      else self.start();
    });

    this.start();
  }

  // ------------------------------------------------------------------
  // Money formatting (mirrors Shopify's own formatMoney)
  // ------------------------------------------------------------------

  function formatMoney(cents, format) {
    var fmt = format || CONFIG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withCommas(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) return 0;

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var value = '';
    var match = fmt.match(placeholder);
    if (!match) return fmt;

    switch (match[1]) {
      case 'amount':
        value = withCommas(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withCommas(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withCommas(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withCommas(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withCommas(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withCommas(cents, 0, ' ', '');
        break;
      case 'amount_with_period_and_space_separator':
        value = withCommas(cents, 2, ' ', '.');
        break;
      default:
        value = withCommas(cents, 2);
    }

    return fmt.replace(placeholder, value);
  }

  // ==================================================================
  // 1 + 2. Urgency bar — live viewers and units sold
  // ==================================================================

  function initUrgency() {
    var root = document.querySelector('[data-mdj-urgency]');
    if (!root) return;

    var productKey = root.getAttribute('data-product-id') || 'product';
    var isHero = root.getAttribute('data-hero') === 'true';
    var vCfg = CONFIG.viewers || {};
    var sCfg = CONFIG.sold || {};

    // ---- Units sold ------------------------------------------------
    // Seeded from the product id AND the current window bucket, so the
    // number holds steady for the whole window and then moves on. A
    // "sold" figure that changes on every refresh is the fastest way to
    // get caught out.
    var soldWrap = root.querySelector('[data-mdj-sold]');
    var soldEl = root.querySelector('[data-mdj-sold-count]');
    if (soldEl && sCfg.enabled) {
      var soldMin = parseInt(sCfg.min, 10) || 5;
      var soldMax = parseInt(sCfg.max, 10) || 25;
      if (soldMax < soldMin) soldMax = soldMin;
      var soldDays = parseFloat(sCfg.days) || 2;

      var bucketMs = soldDays * 24 * 60 * 60 * 1000;
      var bucket = Math.floor(Date.now() / bucketMs);

      // Bestsellers sit in the upper half of the band, everything else
      // uses the full range.
      var lo = isHero ? Math.round(soldMin + (soldMax - soldMin) * 0.45) : soldMin;
      soldEl.textContent = String(seededInt(productKey + ':sold:' + bucket, lo, soldMax));

      var soldLabel = root.querySelector('[data-mdj-sold-label]');
      if (soldLabel) soldLabel.textContent = sCfg.label || '';
      if (soldWrap) soldWrap.hidden = false;
    }

    // ---- Live viewers ----------------------------------------------
    var viewWrap = root.querySelector('[data-mdj-viewers]');
    var viewEl = root.querySelector('[data-mdj-viewers-count]');
    if (!viewEl || !vCfg.enabled) return;

    var vMin = parseInt(vCfg.min, 10) || 12;
    var vMax = parseInt(vCfg.max, 10) || 80;
    var everyMs = (parseFloat(vCfg.everySeconds) || 3) * 1000;
    var mode = vCfg.mode || 'drift';
    var vBoost = isHero;

    if (vMax < vMin) vMax = vMin;

    var viewLabel = root.querySelector('[data-mdj-viewers-label]');
    if (viewLabel) viewLabel.textContent = vCfg.label || '';
    if (viewWrap) viewWrap.hidden = false;

    // Each product gets a base level that shifts hourly. Bestsellers sit
    // higher in the band than slow movers, which is what a real counter
    // would look like.
    var hourBucket = Math.floor(Date.now() / (60 * 60 * 1000));
    var baseLo = vBoost ? Math.round(vMin + (vMax - vMin) * 0.5) : vMin;
    var base = seededInt(productKey + ':view:' + hourBucket, baseLo, vMax);

    // Keep the wander tight around the base so the number reads as one
    // product's traffic rather than a slot machine.
    var span = Math.max(3, Math.round((vMax - vMin) * 0.18));
    var current = base;

    function paint(n) {
      viewEl.textContent = String(n);
      if (reduceMotion) return;
      viewEl.classList.remove('is-ticking');
      // Force reflow so the animation restarts on every tick.
      void viewEl.offsetWidth;
      viewEl.classList.add('is-ticking');
    }

    paint(current);

    new LiveInterval(function () {
      if (mode === 'reroll') {
        current = randInt(vMin, vMax);
      } else {
        var step = randInt(1, 4) * (Math.random() < 0.5 ? -1 : 1);
        current = clamp(current + step, Math.max(vMin, base - span), Math.min(vMax, base + span));
      }
      paint(current);
    }, everyMs);
  }

  // ==================================================================
  // 3. Frequently bought together
  // ==================================================================

  function initFbt() {
    var root = document.querySelector('[data-mdj-fbt]');
    if (!root) return;

    var btn = root.querySelector('[data-mdj-fbt-add]');
    var totalEl = root.querySelector('[data-mdj-fbt-total]');
    var savingEl = root.querySelector('[data-mdj-fbt-saving]');
    var errorEl = root.querySelector('[data-mdj-fbt-error]');
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-mdj-fbt-check]'));
    if (!btn || !boxes.length) return;

    var f = CONFIG.fbt || {};
    var addOnDiscount = parseFloat(f.discount) || 0; // percent

    function setText(sel, value) {
      var el = root.querySelector(sel);
      if (el && value) el.textContent = value;
    }

    setText('[data-mdj-fbt-heading]', f.heading);
    setText('[data-mdj-fbt-this-item]', f.thisItemLabel);
    setText('[data-mdj-fbt-total-label]', f.totalLabel);
    setText('[data-mdj-fbt-add]', f.buttonLabel);

    var noteEl = root.querySelector('[data-mdj-fbt-note]');
    if (noteEl && f.note) {
      noteEl.textContent = f.note;
      noteEl.hidden = false;
    }

    // Honour "show 1 add-on instead of 2" without re-rendering server side.
    var addonRows = Array.prototype.slice.call(root.querySelectorAll('[data-mdj-fbt-addon]'));
    var maxAddons = parseInt(f.count, 10) || addonRows.length;
    addonRows.forEach(function (row, i) {
      if (i >= maxAddons) {
        row.remove();
        return;
      }
      if (addOnDiscount <= 0) return;

      // The prices in this row are rendered by Liquid and left alone. The
      // store already uses Shopify's compare-at price, so the only struck
      // through number on a row is that compare-at. Stacking a second
      // strikethrough for the bundle discount reads as a fake markdown, so
      // the 5% is announced as an EXTRA saving taken at checkout instead.
      var saveEl = row.querySelector('[data-mdj-fbt-save]');
      if (saveEl) {
        saveEl.textContent = '+' + addOnDiscount + '% extra at checkout';
        saveEl.hidden = false;
      }
    });

    // Rows may have been removed just above, so re-read the live set.
    boxes = Array.prototype.slice.call(root.querySelectorAll('[data-mdj-fbt-check]'));

    var defaultLabel = btn.textContent.trim();

    // The anchor product's variant can change via the variant picker, so
    // read it live from the theme's own product form rather than caching.
    function anchorVariantId(fallback) {
      var form = document.querySelector(
        '.product__info-container product-form form [name="id"], product-form form [name="id"]'
      );
      return (form && form.value) || fallback;
    }

    function selected() {
      return boxes.filter(function (b) {
        return b.checked;
      });
    }

    function recalc() {
      var total = 0;
      var saving = 0;

      selected().forEach(function (b) {
        var price = parseInt(b.getAttribute('data-price'), 10) || 0;
        total += price;
        // The bundle discount only ever applies to the additional products,
        // never to the item the shopper came for.
        if (b.getAttribute('data-anchor') !== 'true') {
          saving += Math.round(price * (addOnDiscount / 100));
        }
      });

      // Total shown is the real shelf total. The bundle saving is stated
      // separately as something that comes off at checkout.
      if (totalEl) totalEl.textContent = formatMoney(total);

      if (savingEl) {
        if (saving > 0) {
          savingEl.textContent =
            'Extra ' + addOnDiscount + '% off the add-on applied at checkout — you save ' +
            formatMoney(saving);
          savingEl.hidden = false;
        } else {
          savingEl.hidden = true;
        }
      }

      btn.disabled = selected().length < 2;
    }

    boxes.forEach(function (b) {
      b.addEventListener('change', recalc);
    });
    recalc();

    function cartHost() {
      return (
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-notification') ||
        null
      );
    }

    btn.addEventListener('click', function () {
      var chosen = selected();
      if (chosen.length < 2) return;

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.classList.remove('is-info');
      }
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.textContent = f.addingLabel || 'Adding…';

      var wanted = chosen.map(function (b) {
        var id = b.getAttribute('data-variant-id');
        if (b.getAttribute('data-anchor') === 'true') id = anchorVariantId(id);
        return Number(id);
      });

      var host = cartHost();
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

      // Read the cart before writing to it. The shopper may already have
      // added the main product with the normal Add to cart button a few
      // centimetres above this box, and adding it again would quietly turn
      // it into a quantity of two at checkout.
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (li) {
            have[li.variant_id] = (have[li.variant_id] || 0) + li.quantity;
          });

          var updates = {};
          var toAdd = 0;
          wanted.forEach(function (id) {
            if (!have[id]) {
              // update.js sets an ABSOLUTE quantity and creates the line if
              // it is missing, so this can never double an existing item.
              // Anything already in the cart is left exactly as it is.
              updates[id] = 1;
              toAdd++;
            }
          });

          if (toAdd === 0) return { mdjAlreadyInCart: true };

          var body = { updates: updates };
          if (host && typeof host.getSectionsToRender === 'function') {
            body.sections = host.getSectionsToRender().map(function (s) {
              return s.id;
            });
            body.sections_url = window.location.pathname;
          }

          return fetch(cartUrl + '/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          }).then(function (r) {
            return r.json();
          });
        })
        .then(function (data) {
          if (data && data.mdjAlreadyInCart) {
            btn.classList.remove('is-loading');
            btn.textContent = defaultLabel;
            recalc();
            if (errorEl) {
              errorEl.classList.add('is-info');
              errorEl.textContent = 'These are already in your cart.';
              errorEl.hidden = false;
            }
            if (host && typeof host.open === 'function') host.open();
            return;
          }
          if (data.status) throw new Error(data.description || data.message || 'Cart error');

          // Let the theme know, so the header count and any cart
          // subscribers stay in step.
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'mdj-fbt',
              productVariantId: wanted[0]
            });
          }

          if (host && data.sections && typeof host.renderContents === 'function') {
            host.classList.remove('is-empty');
            host.renderContents(data);
            if (typeof host.open === 'function') host.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }

          btn.classList.remove('is-loading');
          btn.textContent = f.addedLabel || 'Added to cart';
          setTimeout(function () {
            btn.textContent = defaultLabel;
            recalc();
          }, 2200);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.textContent = defaultLabel;
          recalc();
          if (errorEl) {
            errorEl.textContent =
              f.errorLabel || 'Sorry, that could not be added. Please try again.';
            errorEl.hidden = false;
          }
          if (window.console) console.warn('[MDJ FBT]', err);
        });
    });
  }

  // ==================================================================
  // 4. Social proof purchase popup
  // ==================================================================

  function initPopup() {
    var el = document.getElementById('MdjPopup');
    if (!el) return;

    var cfg = CONFIG.popup || {};
    var products = cfg.products || [];
    if (!products.length) return;

    // A shopper who closed it should not see it again this visit.
    try {
      if (sessionStorage.getItem('mdj-pop-dismissed') === '1') return;
    } catch (e) {
      /* private mode — carry on */
    }

    var path = window.location.pathname;
    if (cfg.hideOnCart !== false && /\/(cart|checkout)/.test(path)) return;

    // Settings arrive as comma-separated text from the Theme editor, so
    // tidy up whatever spacing the merchant typed.
    function cleanList(list) {
      return (list || [])
        .map(function (s) {
          return String(s).trim();
        })
        .filter(function (s) {
          return s.length > 0;
        });
    }

    var femaleNames = cleanList(cfg.femaleNames);
    var maleNames = cleanList(cfg.maleNames);
    var cities = cleanList(cfg.cities);
    if (!femaleNames.length && !maleNames.length) return;

    var femaleShare = typeof cfg.femaleShare === 'number' ? cfg.femaleShare : 80;
    var intervalMs = (cfg.intervalSeconds || 20) * 1000;
    var showMs = (cfg.showSeconds || 3) * 1000;
    var firstMs = (cfg.firstDelaySeconds || 8) * 1000;
    var minAgo = cfg.minMinutesAgo || 1;
    var maxAgo = cfg.maxMinutesAgo || 45;

    var thumbEl = el.querySelector('[data-mdj-pop-thumb]');
    var nameEl = el.querySelector('[data-mdj-pop-name]');
    var cityEl = el.querySelector('[data-mdj-pop-city]');
    var productEl = el.querySelector('[data-mdj-pop-product]');
    var timeEl = el.querySelector('[data-mdj-pop-time]');
    var closeEl = el.querySelector('[data-mdj-pop-close]');

    // Shuffle once, then walk the deck, so the same product does not
    // appear twice in a row.
    var deck = products.slice();
    for (var i = deck.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = deck[i];
      deck[i] = deck[j];
      deck[j] = tmp;
    }
    var cursor = 0;

    function nextProduct() {
      if (cursor >= deck.length) cursor = 0;
      return deck[cursor++];
    }

    function pickName() {
      var wantFemale = Math.random() * 100 < femaleShare;
      var pool = wantFemale ? femaleNames : maleNames;
      if (!pool.length) pool = femaleNames.length ? femaleNames : maleNames;
      return pool[Math.floor(Math.random() * pool.length)];
    }

    function timeAgo() {
      var mins = randInt(minAgo, maxAgo);
      if (mins <= 1) return cfg.justNowLabel || 'just now';
      if (mins < 60) return mins + ' ' + (cfg.minutesAgoLabel || 'minutes ago');
      var hrs = Math.round(mins / 60);
      return hrs + ' ' + (hrs === 1 ? cfg.hourAgoLabel || 'hour ago' : cfg.hoursAgoLabel || 'hours ago');
    }

    var hideTimer = null;

    function show() {
      var p = nextProduct();
      if (!p) return;

      if (thumbEl) {
        if (p.image) {
          thumbEl.src = p.image;
          thumbEl.alt = p.title || '';
          thumbEl.hidden = false;
        } else {
          thumbEl.hidden = true;
        }
      }
      if (nameEl) nameEl.textContent = pickName();
      if (cityEl) cityEl.textContent = cities.length
        ? cities[Math.floor(Math.random() * cities.length)]
        : '';
      if (productEl) productEl.textContent = p.title || '';
      if (timeEl) timeEl.textContent = timeAgo();
      if (p.url) el.setAttribute('href', p.url);

      el.classList.add('is-visible');

      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        el.classList.remove('is-visible');
      }, showMs);
    }

    if (closeEl) {
      closeEl.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        el.classList.remove('is-visible');
        clearTimeout(hideTimer);
        if (loop) loop.stop();
        try {
          sessionStorage.setItem('mdj-pop-dismissed', '1');
        } catch (e) {
          /* ignore */
        }
      });
    }

    var loop = null;
    setTimeout(function () {
      show();
      loop = new LiveInterval(show, intervalMs);
    }, firstMs);
  }

  // ------------------------------------------------------------------
  // Boot
  //
  // The counters and FBT box are part of the page the shopper is reading,
  // so they run as soon as the DOM is ready. The popup is decoration —
  // it waits for an idle moment so it can never compete with LCP.
  // ------------------------------------------------------------------

  function boot() {
    initUrgency();
    initFbt();

    var startPopup = function () {
      initPopup();
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(startPopup, { timeout: 3000 });
    } else {
      setTimeout(startPopup, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
